require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./workshops-impact-mapping.json") })
        }
      }, "path---workshops-impact-mapping");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---workshops-impact-mapping!./.cache/json/workshops-impact-mapping.json
// module id = 503
// module chunks = 231608221292675